import { useQuery } from '@tanstack/react-query';
import { strapiListCompanyBranches } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useCompanyBranchesQuery(jwt: string | null) {
  return useQuery({
    queryKey: queryKeys.companyBranches(jwt),
    queryFn: () => strapiListCompanyBranches(jwt!),
    enabled: Boolean(jwt),
    staleTime: 5 * 60 * 1000,
  });
}
